"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.commonModels_en_us = void 0;
function commonModels_en_us() {
    return {
        "models.identifier": "Identifier",
        "models.creationdate": "Creation Date",
        "models.createdat": "Created at"
    };
}
exports.commonModels_en_us = commonModels_en_us;
